import Router from "vue-router";
import { VueModule } from "vue-modules";
import { Vue as _Vue } from "vue/types/vue";
// @ts-ignore
import { pathOr } from "ramda";
import { checkAuthenticated } from "@/shared/utils";

export class RouterModule implements VueModule {
  readonly name = "router";
  router?: Router;
  install(Vue: typeof _Vue) {
    Vue.use(Router);

    this.router = new Router({
      mode: "history",
      base: "/v2",
      linkActiveClass: "open active",
    });

    this.router.beforeEach(async (to, from, next) => {
      const siteTitle = process.env.VUE_APP_TITLE || "";
      window.document.title =
        to.meta && to.meta.label
          ? `${siteTitle} | ${to.meta.label}`
          : siteTitle;

      const isDeprecatedRoute = pathOr(false, ["meta", "deprecated"], to);
      if (isDeprecatedRoute) {
        const routeFullPath = pathOr("", ["fullPath"], to);
        const baseUrl = process.env.VUE_APP_BASE_URL;
        const url = `${baseUrl}${routeFullPath}`;
        window.open(url, "_self");
        return;
      }

      // check if user is authenticated
      if (to.matched.some(({ meta }) => meta.requiresAuth)) {
        const isAuthenticated = await checkAuthenticated();
        if (isAuthenticated) {
          next();
          return;
        }
        next("/auth");
      } else {
        next();
      }
    });
  }
}
